export default {
  Inputfield: "Por favor ingrese",
  Dropdownfield: "Por favor seleccione",
  Searchfield: "Buscar <nombre del objeto>",
  createOrSelectTag: "Crear o seleccionar etiqueta",
};
